import React, { useContext, useState, useEffect } from 'react';

import {
    CssBaseline,
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Hidden,
    Tooltip,
    LinearProgress
} from '@material-ui/core';

import {
} from '../common';

import { AuthContext } from '../contexts/AuthContext';
import { NavContext, NavRoutes } from '../contexts/NavContext';
import { UserContext } from '../contexts/UserContext';

import { useBusyState } from '../../helpers';

import ExitToAppIcon from '@material-ui/icons/ExitToAppOutlined';

import LogoCDI from '../../images/logo_cdi_white.png'

import { makeStyles, useTheme } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
    root: {
        display: "flex",
    },
    appBar: {
        backgroundColor: "#0a4682",
    },
    toolbarButton: {
        marginLeft: theme.spacing(1),
        color: "#FFF"
    },
    logo: {
        width: "80px",
        margin: theme.spacing(3)
    },
    title: {
        flexGrow: 1
    },
    user: {
        marginLeft: theme.spacing(1)
    },
    content: {
        flexGrow: 1
    }
}));

export const Layout = ({ ...props }) => {
    const classes = useStyles();
    const theme = useTheme();

    const {
        navigateTo,
        switchTo
    } = useContext(NavContext);

    const {
        state: { isAuthenticated },
        getAccountInfo,
        logOut
    } = useContext(AuthContext);

    const {
        getMeAsync,
        state: { me: userInfo }
    } = useContext(UserContext);

    const [isReady, setIsReady] = useState(false);
    const loadCurrentUserAsync = async () => {
        setIsReady(false);
        setIsBusy({ getMe: true });
        await getMeAsync();
        setIsBusy({ getMe: false });
        setIsReady(true);
    }

    const logoutClickHandler = () => {
        logOut();
    }

    const accountInfo = getAccountInfo();
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [userEmail, setUserEmail] = useState(accountInfo ? accountInfo.email : null);
    const [userFullName, setUserFullName] = useState(accountInfo ? accountInfo.fullName : null);

    useEffect(() => {
        if (isAuthenticated) {
            const accountInfo = getAccountInfo();
            setUserEmail(accountInfo.email);
            setUserFullName(accountInfo.fullName);
            loadCurrentUserAsync();
        } else {
            setIsReady(true);
        }
    }, [isAuthenticated]);

    return (

        <div className={classes.root}>
            <main className={classes.content}>
                <CssBaseline />
                {isReady && isAuthenticated &&
                    <AppBar position="static" className={classes.appBar}>
                        <Toolbar>
                            <img className={classes.logo} src={LogoCDI} alt="CDI Logo" />
                            <Typography variant="h6" noWrap className={classes.title}>
                                Prenota Appuntamento
                            </Typography>
                            <Hidden smDown>
                                <Typography variant="caption" noWrap className={classes.user}>
                                    benvenuto <Typography variant="subtitle2" component="span">{userFullName}</Typography>
                                </Typography>
                            </Hidden>
                            <IconButton
                                aria-label="logout"
                                className={classes.toolbarButton}
                                onClick={logoutClickHandler}>
                                <Tooltip title="Esci">
                                    <span>
                                        <ExitToAppIcon className={classes.toolbarButton} />
                                    </span>
                                </Tooltip>
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                }
                {isBusy() && <LinearProgress />}
                {isReady && props.children}
            </main>
        </div>
    );
}